import { useEffect, useState } from "react";
import { obterSomenteConsulta } from "../services/tabelaPrecoService";

/**
 * FASE 05 — item 3 do relatorio do PO de 11/08/2026.
 *
 * Indica se a empresa logada esta com a chave "Liberação das tabelas de preços apenas
 * para consulta" (Gerência > Empresas > Tabela de Preços). Com ela ligada, a tela some
 * com o "Modo edição", com o "Adicionar nova tabela" e com as ações de gravação da
 * página de precificação — mesmo padrão do `useApenasConsulta` dos Produtos N1.
 *
 * A chave persiste como a tela `ConsultaTabelasPreco` da empresa; o endpoint
 * `GET /api/TabelaPreco/PermissoesMof` do legado resolve isso pelo JWT.
 */
export const useSomenteConsultaTabelaPreco = (): { somenteConsulta: boolean; carregando: boolean } => {
  const [somenteConsulta, setSomenteConsulta] = useState(false);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    let ativo = true;

    obterSomenteConsulta()
      .then((valor) => {
        if (ativo) setSomenteConsulta(valor);
      })
      .finally(() => {
        if (ativo) setCarregando(false);
      });

    return () => {
      ativo = false;
    };
  }, []);

  return { somenteConsulta, carregando };
};
